/**
 *
 * Top Right Nav Bar Tabs
 *
 */
//import { FaMoon } from 'react-blackIcons/fa';
//import { FiSun } from 'react-blackIcons/fi';
import React from 'react';

import { Box, HStack, IconButton } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useWindowSize } from 'react-use';

import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';
import { SearchBox } from 'components/DataEntry/Input/SearchBox';
import { FilterComponent } from 'components/FilterView';
import {
  DocumentsIcon,
  OrganizationIcon,
  RuntimeInsightsIcon,
} from 'components/Icons';
import { useNavBarContext } from 'components/Navigation/NavBar/context';
import { useDocsPanel } from 'containers/Documentation/DocsPanel/context';
import { isDocumentationPath } from 'containers/Documentation/DocsPanel/utils';

import { iconStyles } from '../styles';

import ProfileMenu from './ProfileMenu';
import { SelectCloudEnvironmentOrAccount } from './SelectEnvironmentOrAccount/SelectCloudEnvironmentOrAccountNew';

export const RightComponent = () => {
  const navigate = useNavigate();
  // Router location (was window.location) so AI vs plain search follows
  // in-app navigation.
  const { pathname } = useLocation();
  const { search, showWelcomeScreen, cloudInsight } = useNavBarContext();
  const docsPanel = useDocsPanel();

  /*const { toggleColorMode } = useColorMode();
  const text = useColorModeValue('light', 'dark');
  const SwitchIcon = useColorModeValue(FaMoon, FiSun);*/

  const aiSearchMapping = {
    '/inventory/cloud': false,
    '/findings': true,
    '/findings/overview': true,
    '/findings/tickets': false,
    '/findings/alerts': true,
    '/visibility/data': false,
    '/visibility/vulnerability': false,
    '/visibility/activity/group': false,
  };

  const size = useWindowSize();

  return (
    <>
      <HStack spacing={1} align="center" flexWrap="nowrap">
        {!showWelcomeScreen && (
          <>
            <FilterComponent includePaths={Object.keys(aiSearchMapping)}>
              <Box w={size.width < 1360 ? '150px' : '180px'} flexShrink={0}>
                <SearchBox
                  onChange={search.onChangeSearchTerm}
                  onSearch={(...args) => {
                    aiSearchMapping[pathname]
                      ? search.onAiSearch(...args)
                      : search.onSearch(...args);
                  }}
                  value={search.value}
                  onClickClose={search.onClearSearch}
                  isLoading={search.isLoading}
                  navBar
                  aiSearchModal={search?.aiSearchModal}
                />
              </Box>
            </FilterComponent>
            <Box flex="0 0 auto" pl={1}>
              <SelectCloudEnvironmentOrAccount />
            </Box>

            <CustomTooltip label={'Runtime Insights'} placement={'bottom'}>
              <Box pos={'relative'} flexShrink={0}>
                <IconButton
                  aria-label="Cloud Insights"
                  icon={<RuntimeInsightsIcon w="17px" />}
                  onClick={() => cloudInsight.onOpen()}
                  {...iconStyles}
                />
              </Box>
            </CustomTooltip>
            {/*<FilterComponent filterPath={`/event-log`}>
              <CustomTooltip label={'Ariksa Event Logs'} placement={'bottom'}>
                <Box pos={'relative'} flexShrink={0}>
                  <IconButton
                    aria-label="Event Log"
                    icon={<EventLogIcon />}
                    onClick={() => navigate('/event-log')}
                    {...iconStyles}
                  />
                </Box>
              </CustomTooltip>
            </FilterComponent>*/}
            <Box pos="relative" flexShrink={0}>
              <CustomTooltip label={'Org settings'} placement={'bottom'}>
                <IconButton
                  aria-label="Organization Settings"
                  icon={<OrganizationIcon w="17px" />}
                  {...iconStyles}
                  onClick={() => navigate('/settings/organization')}
                />
              </CustomTooltip>
            </Box>
            {/*<IconButton
        aria-label={`${text} mode`}
        onClick={toggleColorMode}
        icon={<SwitchIcon />}
        {...iconStyles}
      />*/}
          </>
        )}
        {!showWelcomeScreen && (
          <CustomTooltip label="Product documentation" placement="bottom">
            <Box pos="relative" flexShrink={0}>
              <IconButton
                aria-label="Product documentation"
                icon={<DocumentsIcon />}
                // With the guide docked, opens it as the full page; otherwise
                // the docs home.
                onClick={() => {
                  if (
                    docsPanel.state.open &&
                    docsPanel.state.path &&
                    !isDocumentationPath(pathname)
                  )
                    docsPanel.expand();
                  else navigate('/documentation');
                }}
                {...iconStyles}
              />
            </Box>
          </CustomTooltip>
        )}
        {/*   <!-- Profile dropdown --> */}

        <Box flexShrink={0}>
          <ProfileMenu />
        </Box>
      </HStack>
    </>
  );
};
